/**
 * iter87.199.58 — PhoneFrame chrome for landing How-it-Works carousel.
 *
 * Pure-CSS iPhone bezel — no image asset. Renders razor-sharp on retina
 * and stays consistent regardless of viewport pixel density. Sized to
 * hold real app UI mock components inside `children`.
 *
 * Geometry ratios follow iPhone 15 (9:19.5) so the mock content inside
 * has a natural mobile aspect. Tweaked once here, inherits everywhere.
 */
import React from "react";

export default function PhoneFrame({ children, tone = "cyber", label }) {
    // Accent tone drives the ambient glow behind the bezel so every
    // slide feels slightly different — Apple product page cadence.
    const glow =
        tone === "volt"  ? "shadow-brutalBlue"
        : tone === "heat"  ? "shadow-brutalRed"
        : tone === "blaze" ? "shadow-brutalOrange"
        : tone === "neon"  ? "shadow-brutalGreen"
        : "shadow-brutalYellow";

    return (
        <div
            data-testid={label ? `phone-frame-${label}` : "phone-frame"}
            className={`relative shrink-0 snap-center select-none rounded-[38px] ${glow}`}
            style={{
                // Two sizes: mobile-tight vs desktop-comfortable. Kept in
                // sync with HowItWorksCarousel gap/scroll padding.
                width: "clamp(240px, 72vw, 280px)",
                height: "clamp(500px, 150vw, 580px)",
            }}
        >
            {/* Outer bezel: matte black shell with subtle border-highlight
                so it doesn't disappear against the section background. */}
            <div
                className="absolute inset-0 rounded-[38px] border-[3px] border-zinc-800 bg-[#0a0a0a]"
                aria-hidden
            />

            {/* Inner screen viewport — content lives here. `overflow-hidden`
                clips oversize mocks; per-slide component owns its scroll if any. */}
            <div className="absolute inset-[8px] rounded-[30px] overflow-hidden bg-[#0A0A0A] flex flex-col">
                {/* Notch — decorative dark pill top-centre. */}
                <div className="relative h-6 flex items-center justify-center">
                    <div className="absolute top-1.5 h-4 w-[28%] rounded-full bg-black" aria-hidden />
                </div>
                <div className="flex-1 min-h-0 overflow-hidden">{children}</div>
            </div>
        </div>
    );
}
